import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import moment from 'moment'
import ReactTable  from "react-table";
import {getToken} from '../../storage'
import AddBatch from './addbatch'

export default class BatchList extends React.Component {


  constructor() {
    super();
    this.state = {
      showBatchForm: true,
      data: [],
      pages: null,
      loading: true
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateBatch = this.goToCreateBatch.bind(this)
    this.deleteBatch = this.deleteBatch.bind(this)
    this.onAddCallback = this.onAddCallback.bind(this)
  }

  goToCreateBatch(e) {
    e.preventDefault()
    this.props.history.push("/batchs/create/")
  }

  deleteBatch(batch_id) {

    var confirmation = window.confirm('Are you sure about delete ?')

    if(confirmation) {
      axios({
        url: '/delete_batch/',
        baseURL: API_BASE_URL,
        method:'post',
        data: {id:batch_id},
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.fetchData()
      }).catch(err=>{
        console.log(err);
      })
    }
  }


  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/batchs/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  onAddCallback() {
    this.fetchData(this.state.tableState)
    this.setState({showBatchForm:false})
    this.setState({showBatchForm:true})
  }



  fetchData(state, instance) {
    this.setState({ loading: true });
      let item = this.props.item
      let item_id
      if(typeof item !== "undefined" && item !== null) {
        item_id = item.id
      }

      if(typeof item_id === "undefined") {
        this.setState({
          data: [],
          pages: 0,
          loading: false
        });
      }

      let apiurl = "/list_batches/?page=" + state.page + '&page_size='+state.pageSize + '&item_id='+item_id;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      this.setState({tableState:state})
      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.batchs,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {
      let showAddBatchForm = this.state.showBatchForm, batchForm
      if(typeof showAddBatchForm !== "undefined" && showAddBatchForm) {
        batchForm = <AddBatch item={this.props.item} onAddCallback={this.onAddCallback}  />
      }
      const { data, pages, loading } = this.state;
      const columns = [
        {Header: 'Name', accessor: 'name',sortable:true },
        {Header: 'Mfg Date', accessor: 'mfg_date', sortable:true, Cell:(row)=>(<div className="text-center">{moment(row.original.mfg_date).format('DD-MM-YYYY')}</div>)},
        {Header: 'Exp Date', accessor: 'expiry_date', sortable:true, Cell:(row)=>(<div className="text-center">{moment(row.original.expiry_date).format('DD-MM-YYYY')}</div>)},
        {Header: 'Closing Stock', accessor: 'closing_stock', sortable:true, Cell:(row)=>(<div className="text-right">{row.original.closing_stock}</div>)},
        {Header: 'Closing Purchase Rate', accessor: 'closing_purchase_basic_rate', sortable:true, Cell:(row)=>(<div className="text-right">{row.original.closing_purchase_basic_rate}</div>)}
      ]
      const defaultSort=[{id: "name", desc: true}]
      return <div><section className="medium">
        <h4>Add Batch </h4>
          {batchForm}
      </section>

      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Batchs Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/batch/batchlist.js